import preparedReducer from './reducer';
import {
  addField,
  updateFormFields,
  updateFormInfo,
  createForm,
  updateForm,
  deleteForm,
  requestForms,
  requestFormInfo,
  updateConfig,
  fillForm,
  updateFormSettings,
  resetForm,
  requestFormFields,
  requestFormEmailSettings,
  updateFormEmailSettings,
} from './actions';

export const reducer = preparedReducer;

export const SLICE_NAME = 'forms';

export const selectors = (state) => state[SLICE_NAME];

export const actions = {
  addField,
  updateFormFields,
  updateFormInfo,
  createForm,
  updateForm,
  deleteForm,
  requestForms,
  requestFormInfo,
  updateConfig,
  fillForm,
  updateFormSettings,
  resetForm,
  requestFormFields,
  requestFormEmailSettings,
  updateFormEmailSettings,
};
